// extracted by mini-css-extract-plugin
export default {"mobileDropdown":"MobileDropdown_mobileDropdown__iVWSN"};